import { createContext, useContext, useState, ReactNode } from 'react'

export const HeaderStateContext = createContext({})

export const HeaderProvider = ({
  children,
  initMember = {},
  initMemberStatus = { status: null, isBlocked: false }
}: {
  children?: ReactNode
  initMember?: Record<string, unknown>
  initMemberStatus?: { status: string | null; isBlocked: boolean }
}) => {
  const [member, setMember] = useState(initMember)
  const [memberStatus, setMemberStatus] = useState(initMemberStatus)

  const state = {
    member,
    setMember,
    memberStatus,
    setMemberStatus
  }

  return <HeaderStateContext.Provider value={state}>{children}</HeaderStateContext.Provider>
}

export const useHeaderContext = () => useContext(HeaderStateContext)
